import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'

type Props = {
  selected: boolean
  onClick: () => void
  disabled?: boolean
  popular?: boolean
}

export default function QuizSelectionOption({
  selected,
  onClick,
  disabled = false,
  popular = false,
  children,
}: PropsWithChildren<Props>) {
  return (
    <div className={clsx('relative', popular && 'mt-4')}>
      {popular && (
        <div className="absolute -top-8 left-4 z-0 rounded-t-md bg-blue-600 px-3 pb-0.5 pt-1 text-base text-white">
          Most popular
        </div>
      )}
      <div
        className={clsx(
          'before:content[""] relative flex cursor-pointer items-center justify-between gap-x-1.5 rounded-xl px-5',
          ' py-6 transition-all duration-150 before:absolute before:left-0 before:top-0 before:z-[2] before:h-full before:w-full before:rounded-xl before:transition-all before:duration-150 lg:py-7',
          'cursor-pointer hover:before:border-gray-400',
          selected
            ? 'before:border-2 before:border-blue-800 hover:before:!border-blue-800'
            : 'before:border before:border-gray-300',
          disabled ? 'pointer-events-none bg-gray-300 opacity-70' : 'bg-white',
        )}
        onClick={() => onClick()}
      >
        {children}
      </div>
    </div>
  )
}
